export class PipeRingVariantModel {
    _id: string;
    piperingId: string;
    name: string;
    description: string;

    constructor(_id = '',
        piperingId = '',
        name = '',
        description = '',
     ) {
            this._id = _id;
            this.piperingId = piperingId;
            this.name = name;
            this.description = description;
    }
}
